// extracted by mini-css-extract-plugin
export var inline = "_vk-0";